export default __webpack_public_path__ + "static/white-paper-mobile-68d8b8d89c5a72953a276bb4fbb3192c.png";